<span id="text" *ngIf="text">{{text}}</span>
<span id="placeHolder" *ngIf="!text" class="text-placeholder" translate>{{placeholderText}}</span>